'use client'

import React from 'react'
import Link from 'next/link'
import clsx from 'clsx'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Error500 from '@/components/Error/Error500'
import Error404 from '@/components/Error/Error404'
import Error401 from '@/components/Error/Error401'
import Error403 from '@/components/Error/Error403'
import ErrorOther from '@/components/Error/ErrorOther'
import styles from './styles.module.scss'

interface ErrorProps {
  statusCode: number
  message?: string
  children?: React.ReactNode
  standalone?: boolean // trueの場合、外側のレイアウトを無視する
}

export default function ErrorLayout({
  statusCode,
  message,
  children,
  standalone = false,
}: ErrorProps) {
  const isServerError = statusCode >= 500 && statusCode < 600

  // エラーコンテンツを共通化
  const errorContent = (
    <>
      <Header />
      <div className='container'>
        <div className={styles.errorWrapper}>
          {statusCode === 404 ? (
            <Error404 />
          ) : statusCode === 401 ? (
            <Error401 />
          ) : statusCode === 403 ? (
            <Error403 />
          ) : statusCode >= 500 ? (
            <Error500 />
          ) : (
            <ErrorOther message={message} />
          )}
          <br />
          <div className={styles.backHomeIcon}>
            <Link href='/' className={styles.backLink}>
              <i className='icon-font-icon_home' />
              <span className={styles.linkText}>ホームへ戻る</span>
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        <Footer />
      </div>
      {children}
    </>
  )

  // standaloneの場合、外側のレイアウトを完全に上書きする
  if (standalone) {
    return (
      <div id='error-standalone-container' className={styles.standaloneContainer}>
        {errorContent}
      </div>
    )
  }

  return (
    <div id='main-container' className={clsx('main-container', { 'non-margin': isServerError })}>
      {errorContent}
    </div>
  )
}
